// extracted by mini-css-extract-plugin
module.exports = {"root":"ScoreRangeIcon_root__xHcGE","large":"ScoreRangeIcon_large__bQOat","small":"ScoreRangeIcon_small__2cQcz"};